export const Messages = {
  //General messages
  optional: "Optional",
  button_previous: "Previous",
  button_next: "Next",
  button_save: "Save",
  button_upload: "Upload",
  ownership_banner: "'s Banner",
  ownership_icon: "'s Icon",

  //Errors
  error_general: "Something went wrong... Plese try again later or contact us!",
  error_size_big: "This file is too big, max size is ",
  error_width_big: "This file is too wide, max width is ",
  error_height_big: "This file is too tall, max height is ",
  error_width_small: "This file is too thin, min width is ",
  error_height_small: "This file is too short, min height is ",
  error_extension: "This file extension is not allowed. Must be ",
  error_mandatory: " is mandatory",
  error_allowed__max: "Max allowed is ",
  error_allowed__min: "Min allowed is ",
  error_icon_no_square: "The icon image must be square",
  error_file_no_4_3: "The image must have 4:3 aspect radio",

  //Homepage
  search_placeholder: "Search for an app",

  //Nav bar options
  navBar_regApp: "Register App",
  navBar_login: "Login",
  navBar_logout: "Logout",

  //Footer options
  footer_FAQs: "FAQs",
  footer_about: "About Us",
  footer_terms: "Terms & Conditions",

  //Email request messages
  email_label: "Email",
  email_placeholder: "alex@email.com",
  name_placeholder: "Alex",
  button_notify: "Notify me",
  email_success: "Your email has been registered",

  //App registration messages
  regApp_step__one: "General Information",
  regApp_step__two: "Multimedia",
  regApp_step__three: "Preview",
  regApp_name__label: "Name",
  regApp_name__placeholder: "Name of your application",
  regApp_summary__label: "Brief Summary",
  regApp_summary__placeholder:
    "A brief summary will help the search engine perform better searches (80 characters max)",
  regApp_description__label: "Description",
  regApp_description__placeholder:
    "A description of your application to help users better understand it (600 characters max)",
  regApp_categories__label: "Categories",
  regApp_categories__placeholder: "Select categories",
  regApp_categories__tooltip:
    "Categories where your application will be grouped",
  regApp_url__label: "Your Application URL",
  regApp_url__placeholder:
    "URL of your application so that users can access it (https://inrupt.com/)",
  regApp_url__error: " must use HTTPS",
  regApp_icon__label: "Icon",
  regApp_icon__tooltip:
    "Icon that identifies your application. Must be PNG and with a maximum size of 1024KB",
  regApp_banner__label: "Banner",
  regApp_banner__tooltip:
    "Image that will be displayed in the app card. Must be PNG or JPEG and with a maximum size of 3000KB",
  regApp_images__label: "Images",
  regApp_images__tooltip:
    "Images that will be shown in the details page of your app. Must be PNG or JPEG with a maximum size of ????",
  regApp_images__placeholder: "Drop your images or click here to upload",
  regApp_videos__label: "Videos",
  regApp_videos__tooltip:
    "URL of the videos that will be shown in the details page of your app. Must be an URL from a Youtube video",
  regApp_videos__error: "The video must be hosted on youtube",
  regApp_videos__placeholder: "Add the link to your Youtube videos",
  regApp_success: "Great! Your app has been registered",

  //Report
  report: "Report",

  //Edit
  edit: "Save",
};
